/**
 * The My Spending category vocabulary (warehouse/MX category names) as the
 * filter dropdowns list them. Kept here so the benefits transaction picker
 * (MY1-3080) and the spending page agree.
 */
export const SPENDING_CATEGORIES = Object.freeze([
    'Shopping',
    'Restaurants & Bars',
    'Groceries',
    'Travel',
    'Entertainment & Recreation',
    'Gas & Fuel',
    'Home & Utilities',
    'Health & Wellness',
    'Transfer',
    'Credit Card Payment',
    'Income',
    'Other',
]);

/**
 * Categories a purchase can fall in — what a benefit usage record could be
 * linked to. Payments, transfers and income are never benefit usage.
 */
export const SPENDING_EXPENSE_CATEGORIES = Object.freeze(
    SPENDING_CATEGORIES.filter(
        (category) =>
            !['Transfer', 'Credit Card Payment', 'Income'].includes(category)
    )
);
